import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { Mgt1Service } from 'src/app/services/mgt1.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../../alert/alert.component';
import { Sh2Service } from 'src/app/services/sh2.service';
@Component({
  selector: 'app-sh2-list',
  templateUrl: './sh2-list.component.html',
  styleUrls: ['./sh2-list.component.css']
})
export class Sh2ListComponent implements OnInit {
  isSearchDivVisible = false;

  public environmentSettings: any;
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  currentURL : any;
  response: boolean;
  TodayDate: NgbDateStruct;
  registerDirectorList: any[];
  masterDirectorList: any[];
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  dtTriggerMasterDirector: Subject<any> = new Subject();
  deleteSh2Details: any;
  doaIssueofRenewedDuplicateShareCerti: any;
  doiRenewedDuplicateShareCerti: any;
  doiRenewedDuplicateShareCertiTo: any;
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  editParticularId: any;

  constructor(private sh2: Sh2Service, private router: Router,private activatedRoute: ActivatedRoute,
     private commonFunction: CommonFunction,private alert: AlertComponent,
    private mgt1Service: Mgt1Service) {
  this.response = false;
}

  ngOnInit() {
    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');
    
    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [8] }],
      dom: 'lBfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'SH-2',
          title: 'SH-2',
          extend: 'excel',
          exportOptions: {
            columns: [0,2,4,5,6,7],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    this.getRegisterDirectorList();
 
    this.currentURL = window.location.href;
    var haseditpermisssion : any = false;
    if(this.currentURL.includes('edit') && !environment.PSS){
        haseditpermisssion = this.commonFunction.validateURL('Director','edit');
    }
    else if(environment.PSS){
      haseditpermisssion = this.commonFunction.validateURL('Director','add');
    }
    haseditpermisssion= false;
 
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; 
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };


  }
  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if (directorData.length){
      this.masterDirectorList = [];
      $("#directormastersh2Table").DataTable().destroy();
      this.masterDirectorList = directorData;
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#directormastersh2Table").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directormastersh2Table").DataTable().columns.adjust().draw();
    });
  }
  addsh2(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh-2','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getRegisterDirectorList() {
    this.registerDirectorList = [];
    this.sh2.getSh2Details({isSearch: false}).subscribe(registerList => {
      $("#directormastersh2Table").DataTable().destroy();
      // this.registerDirectorList = registerList.data;
      var Sh2data = registerList.data;
      Sh2data.forEach(element => {
        var mgt1Id = element.mgt1Id;
        this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
          // this.Mgt1List.push(MgtList.data);
          MgtList.data.forEach(data => {
            data.detailsOfHoldings.forEach(item => {
              if(item._id == mgt1Id){
                element.ogShareCertiNumber = item.certificateNo;
                element.namePersonRenewedDuplicateCertiisIssued = data.personalDetails.nameOfMember;
              }
            })
          })
        })
        this.registerDirectorList.push(element);
        
      });
      this.dtTriggerRegisterDirector.next();
      // setTimeout(() => {
      //   this.dtTriggerRegisterDirector.next();
      // }, 200);
    });
  }

  confirmDelete(id) {
    this.deleteSh2Details = id;
    $("#deleteConfirm").modal('toggle');
  }

  removesh2detail(){
    this.sh2.removesh2details(this.deleteSh2Details)
    .subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        $("#directormastersh2Table").DataTable().destroy();
        this.getRegisterDirectorList();
        $("#deleteConfirm").modal('toggle');
      }
      else
      {
        this.alert.error(response.message);
      }
    });
 }
 editsh2(_id) {
  this.router.navigate(
    [{ outlets: { 'structure-outlet': ['sh-2','edit',_id]  } }],
    { relativeTo: this.activatedRoute.parent });
  // this.router.navigate(['sh-2/edit/', _id]);
  }

  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.doiRenewedDuplicateShareCerti,
      toDate: this.doiRenewedDuplicateShareCertiTo,
      date1: this.doaIssueofRenewedDuplicateShareCerti
    }
    this.sh2.generateSh2Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.sh2.downloadSh2File(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.sh2.downloadSh2PdfFile(id, 'Multi');
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  
  doAdvSearch(){
    this.response = true;
    var searchParam =
    {
      "doaIssueofRenewedDuplicateShareCerti":this.setDate(this.doaIssueofRenewedDuplicateShareCerti),
      "doiRenewedDuplicateShareCerti":this.setDate(this.doiRenewedDuplicateShareCerti),
      "doiRenewedDuplicateShareCertiTo":this.setDate(this.doiRenewedDuplicateShareCertiTo),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#directormastersh2Table").DataTable().destroy();
    this.sh2.getSh2Details(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
    
  }

  clearAdvSearch(){
    this.doaIssueofRenewedDuplicateShareCerti = '';
    this.doiRenewedDuplicateShareCerti='';
    this.doiRenewedDuplicateShareCertiTo='';
    $("#directormastersh2Table").DataTable().destroy();
    this.doAdvSearch();
    this.response = false;
   
  }

}
